import { format, parseISO } from 'date-fns'

export const convertDbTimestampToString = (timestamp) => {
  if (!timestamp) return ''

  const parsed = parseISO(timestamp)
  const formatted = format(parsed, 'yyyy-MM-dd HH:mm:ss')
  return formatted
}
